/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API19969Req {
  
  /** 手机号 */
  telephone?: string;
  /** REGISTER RESET_PWD OLD_PHONE NEW_PHONE WX_BIND MANAGER_BANKCARD ADD_ALIPAY_ACCOUNT ACCOUNT_AUTHENTICATION */
  codeType?: string;
};



export interface API19969Res {
  /**   */
  code?: number;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  
};


// 19969 发送手机号码验证码

export interface IUsePostAPI19969Return {
  /** 发送手机号码验证码: 接口请求状态 */
  isAPI19969Loading: boolean;
  /** 发送手机号码验证码: 接口请求返回数据 */
  dataAPI19969: API19969Res;
  /**  发送手机号码验证码: 接口数据请求方法 */
  fetchAPI19969Data:  (inputs: API19969Req, config?: YWRequestConfig) => Promise<API19969Res>;
  /** 发送手机号码验证码: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI19969 = ():IUsePostAPI19969Return => {
  let isMount = true;
  const [isAPI19969Loading, setIsAPI19969Loading] = useState(false);
  const [dataAPI19969, setDataAPI19969] = useState<API19969Res>({} as API19969Res);
  const requestUrl = `${basePath}/ywwl-admin/user/sendMtCode`;

  const fetchAPI19969Data = async (inputs: API19969Req, config?: YWRequestConfig): Promise<API19969Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API19969Req>) || {}) as API19969Req;
    
  
    if ( isMount ) {
      setIsAPI19969Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API19969Res>(`${basePath}/ywwl-admin/user/sendMtCode`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI19969(res || {} as API19969Res);
        setIsAPI19969Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI19969Loading(false);
      }
      return false as unknown as API19969Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI19969Loading,
    dataAPI19969,
    fetchAPI19969Data,
    requestUrl,
  }
}

